(function() {
  const selectors = {
    'initSliderHandler': '.js-init-bestsellers-slider',
    'section': '.bestsellers',
    'bestsellerItem': '.bestsellers__item',
    'sliderDots': '.bestsellers__dots',

    'sliderNoDotsClass': 'bestsellers--no-dots'
  }

  function initColorSlider(slide) {
    const section = document.querySelector(selectors.section);
    const hex = slide.dataset.itemColor.replace('#', '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);
    const brightness = (r + g + b) / 3;

    section.style.setProperty('--bestsellers-main-color', brightness < 128 ? '#fff' : '#000');
    section.style.setProperty('--bestsellers-background-color', slide.dataset.itemColor);
  }

  function initSlider() {
    $(selectors.initSliderHandler).each(function() {
      $(selectors.initSliderHandler).on('init', function(event, slick) {
        initColorSlider(slick.$slides[slick.currentSlide]);
      });

      $(selectors.initSliderHandler).on('afterChange', function(event, slick, currentSlide) {
        initColorSlider(slick.$slides[slick.currentSlide]);
      });

      $(this).slick({
        infinite: false,
        dots: true,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        appendDots: $(this).closest(selectors.section).find(selectors.sliderDots),
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              variableWidth: true,
              centerMode: true,
              infinite: true,
            }
          },
        ],
      });

      if (
        $(this).find(selectors.bestsellerItem).length <= 3 &&
        window.innerWidth > 768
      ) {
        $(this).closest(selectors.section).addClass(selectors.sliderNoDotsClass);
      } else {
        $(this).closest(selectors.section).removeClass(selectors.sliderNoDotsClass);
      }
    });
  }

	initSlider();

  window.addEventListener('resize', () => {
    initSlider();
  });
})();
